import { viewContent } from "./events/GA4";
import { pageViewCards, pageView } from "./events/GA4/pageView";
import { selectItem } from "./events/GA4/selectItem";

interface Events {
  [key: string]: Array<
    (props: {
      eventId?: string;
      globalData: Record<string, unknown>;
      value: Record<string, unknown>;
    }) => void
  >;
}

const events = (): Events => {
  return {
    "accountlist:click": [selectItem],
    "content:click": [selectItem],
    "login:errors": [viewContent],
    "login:form_errors": [viewContent],
    "login:view": [viewContent],
    "loginaccessissues:click": [selectItem],
    "loginpage:click": [selectItem],
    pageView: [pageView],
    "paymentmethods:click": [selectItem],
    "paymentmethods:view": [pageViewCards],
    "qdccard:click": [selectItem],
    "signup:form_errors": [viewContent],
    "signuppage:click": [selectItem],
  };
};

export default events;
